import { StructureType, StructureTypeOptions } from '../LoanConstants';

export const getStructureTypeShortName = (typeId: StructureType) => {
    const item = StructureTypeOptions.find((a) => {
        return a.id === typeId;
    });
    return item?.shortName ?? '';
};
